export default async ({
    req,
    res
}) => {
    const uuidV1 = require('uuid/v1');
    if (process.server) {
        if (req && res && req.cookies && res.cookie && !req.cookies["uuid"]) {
            res.cookie("uuid", uuidV1(), {
                expires: new Date(Date.now() + 36500 * 1000 * 60 * 60 * 24)
            });
        }
    } else {
        var Cookie = require('js-cookie');
        if (!Cookie.get("uuid")) {
            Cookie.set("uuid", uuidV1(), {
                expires: 36500
            });
        }
    }
};